<template>
    <div>
       <h2> email: admin@wealtheir.in </h2>
    </div>
</template>